const info = [
    {
        name:"layerMore1",
        el:"#layer-more1",
        btn:".privacy__more--1",
    },
    {
        name:"layerMore2",
        el:"#layer-more2",
        btn:".privacy__more--2",
    },
    {
        name:"layerSylph",
        el:"#layer-sylph",
        btn:"#tree-sylph",
    },
    {
        name:"layerKamael",
        el:"#layer-kamael",
        btn:"#tree-kamael",
    },
    {
        name:"layerHuman",
        el:"#layer-human",
        btn:"#tree-human",
    },
    {
        name:"layerElf",
        el:"#layer-elf",
        btn:"#tree-elf",
    },
    {
        name:"layerDarkelf",
        el:"#layer-darkelf",
        btn:"#tree-darkelf",
    },
    {
        name:"layerOak",
        el:"#layer-oak",
        btn:"#tree-oak",
    },
    {
        name:"layerDwarf",
        el:"#layer-dwarf",
        btn:"#tree-dwarf",
    }
];

export default info;


// WEBPACK FOOTER //
// ./src/js/create/layer-info.js